import { filterNullElements } from '@common/adapters/spaDayAdapter';

const getNumberOfSelectionsPerGuest = (values) =>
  Object.values(filterNullElements(values.treatments))
    .map((selections) => selections.map((selection) => selection.value.value || selection.value.id))
    .flat()
    .reduce(
      (accumulator, userId) => ({
        ...accumulator,
        [userId]: accumulator[userId] + 1 || 1,
      }),
      {}
    );

const isNumberOfSelectionsPerGuestLessThanRequired = (
  numberOfSelectionsPerGuest,
  requiredItemsPerGuest,
  numberOfGuests
) =>
  numberOfGuests > Object.keys(numberOfSelectionsPerGuest).length ||
  Object.values(numberOfSelectionsPerGuest).find((selection) => selection < requiredItemsPerGuest);

const isNumberOfSelectionsPerGuestMoreThanRequired = (
  numberOfSelectionsPerGuest,
  requiredItemsPerGuest,
  numberOfGuests
) =>
  numberOfGuests < Object.keys(numberOfSelectionsPerGuest).length ||
  Object.values(numberOfSelectionsPerGuest).find((selection) => selection > requiredItemsPerGuest);

export const validate = (values, { selectedGuests, spaEntity }) => {
  const errors = {};
  const numberOfGuests = selectedGuests?.length;

  if (values.selectionGroups) {
    const { selectionGroups } = spaEntity;

    const selectionGroupsErrors = Object.entries(values.selectionGroups).reduce(
      (groupErrors, [key, values]) => {
        const id = parseInt(key.split('-')[1], 10);
        const { required: requiredItemsPerGuest } = selectionGroups.find(
          (group) => group.id === id
        );

        const numberOfSelectionsPerGuest = getNumberOfSelectionsPerGuest(values);

        if (
          isNumberOfSelectionsPerGuestMoreThanRequired(
            numberOfSelectionsPerGuest,
            requiredItemsPerGuest,
            numberOfGuests
          )
        ) {
          return {
            ...groupErrors,
            [key]: 'too_many_selections',
          };
        }

        if (
          isNumberOfSelectionsPerGuestLessThanRequired(
            numberOfSelectionsPerGuest,
            requiredItemsPerGuest,
            numberOfGuests
          )
        ) {
          return {
            ...groupErrors,
            [key]: 'too_few_selections',
          };
        }

        return groupErrors;
      },
      {}
    );

    if (Object.keys(selectionGroupsErrors)?.length > 0) {
      errors.selectionGroups = selectionGroupsErrors;
    }
  }

  if (spaEntity?.selectionGroups?.length > 0 && !values.selectionGroups) {
    const selectionId = Object.values(spaEntity.selectionGroups)[0].id;

    errors.selectionGroups = {
      [`group-${selectionId}`]: 'too_few_selections',
    };
  }

  return errors;
};
